// React 19 removed `findDOMNode`, but @stenajs-webui/core 18.x still imports it from
// `react-dom`. In React 19 a host-component ref's `.current` is already the DOM node,
// which is exactly how stenajs calls it (`findDOMNode(ref.current)`), so returning the
// node itself reproduces the old behaviour. This shim re-exports react-dom and adds the
// polyfill. Aliased in webpack.config.js via `react-dom$`.
const ReactDOM = require('react-dom-original');

if (typeof ReactDOM.findDOMNode !== 'function') {
  ReactDOM.findDOMNode = function findDOMNode(instance) {
    if (instance == null) return null;
    if (instance.nodeType) return instance; // already a DOM node (React 19 host ref)
    return null;
  };
}

module.exports = ReactDOM;
